import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { youtubeVideoBlocksForSelect } from '../../../../../utils/blocks-helper';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { BlockMaximumCount } from '../../../../../models/template/block-maximum-count.interface.';
import { BlockMinimumCount } from '../../../../../models/template/block-minimum-count.interface';
import { UniqueTextConstraint } from '../../../../../models/template/unique-text-constraint.interface';

const EMPTY_SITELINK = { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' };

@Component({
    selector: 'app-youtube-video-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/youtube-video-template/"
      channelLabel="Google YouTube Video Ad"
      namePlaceholder="Enter Google YouTube Video Ad template name"
      emptyMessage="No Google YouTube Video Ad found!"
      heartbeatType="youtube-video-template"
      [enableBlockToolbar]="true"
      [showSidePreview]="true"
      [blockCatalog]="blockCatalog"
      [defaultBlocks]="defaultBlocks"
      [blockMaximumCount]="blockMaximumCount"
      [blockMinimumCount]="blockMinimumCount"
      [uniqueTextConstraints]="uniqueTextConstraints"
      />
  `
})
export class YoutubeVideoTemplateComponent {
  protected readonly templateType = TypeEnum.GOOGLE_YOUTUBE_VIDEO;
  protected readonly blockCatalog = youtubeVideoBlocksForSelect;

  protected readonly blockMaximumCount: BlockMaximumCount[] = [
    { blockName: 'youtube-video-sitelink', limit: 20 },
  ];

  protected readonly blockMinimumCount: BlockMinimumCount[] = [
    { blockName: 'youtube-video-sitelink', treshold: 1 },
  ];

  protected readonly uniqueTextConstraints: UniqueTextConstraint[] = [
    { blockName: 'youtube-video-sitelink', fields: ['Text'] },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  // Sitelinks go last: one added from the block dropdown is pushed to the end.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'youtube-video-headline', count: 1, variables: { YoutubeVideoHeadline: '' } },
    { name: 'youtube-video-youtube-url', count: 1, variables: { YoutubeVideoUrl: '' } },
    { name: 'youtube-video-url', count: 1, variables: { Link: '' } },
    { name: 'youtube-video-cta-text', count: 1, variables: { YoutubeVideoCtaText: '' } },
    { name: 'youtube-video-sitelink', count: 1, variables: { ...EMPTY_SITELINK } },
  ];
}
